<div class="address-section">
    <div *ngIf="errorMessage" class="row search-section py-2">
        <div class="col-12">
            <div  class="error-message py-2">
                <span>{{errorMessage}}</span>
            </div>
        </div>
    </div>
    <div class="row py-2">
        <div class="col-12 ">
            <app-address-details [addressData]="addressData" [isLookup]="false" (searchAddressEvent)="searchAddress($event)"></app-address-details>
        </div>
    </div>
    <div class="address-footer pb-3">
        <p-divider></p-divider>
        <div class="text-center">
            
        </div>
    </div>
</div>
<ng-template #updateAddressFooter>
    <button type="button" class="pn-button pn-button-primary pn-button-sm me-2" (keydown.enter)="submitAddress()"
        (click)="submitAddress()" [disabled]="isUpdateBtnDisabled">Update</button>
    <button type="button" class="pn-button pn-button-tertiary pn-button-sm me-2" (keydown.enter)="closePopup()"
        (click)="closePopup()">Cancel</button>
</ng-template>